import { useSelector } from '@xstate/react'

import { Interactions, trackingService } from '../machines/tracking.machine'
import { SelectOptions } from '../types/global'
import { annualConsumptionSelector, useNaturalPowerContext } from './NaturalPowerCalculatorProvider'
import { Select } from './Select'
import { Tile } from './Tile'
import { Tooltip } from './Tooltip'

interface ConsumptionInputProps {
  options: SelectOptions<number>
}

export function ConsumptionInput({ options }: ConsumptionInputProps) {
  const services = useNaturalPowerContext()
  const annualConsumption = useSelector(services.costInput, annualConsumptionSelector)

  const handleChange = (annualConsumption: number) => {
    services.costInput.send({ type: 'Update inputs', annualConsumption: Number(annualConsumption) })
    trackingService.send({ type: 'Interact', name: Interactions.annualConsumption })
  }

  return (
    <Tile
      className="h-24 focus-within:z-20"
      inputId="annualConsumption"
      label={
        <>
          Estimated annual consumption <small className="text-2xs">(kWh)</small>
        </>
      }>
      <div className="flex items-end w-full gap-x-7">
        <Select
          id="annualConsumption"
          options={options}
          onChange={handleChange}
          value={annualConsumption}
          aria-describedby="annualConsumption-tooltip"
        />

        <Tooltip id="annualConsumption-tooltip" title="Estimated annual consumption" className="w-6 h-6 p-1">
          <p>
            This is the average amount of energy for a small-medium sized business. Simply choose from the drop down to
            select an alternative estimated range.
          </p>
          <p>
            For a more accurate view, login to your MyAccount, check your latest bill or speak to your Account Manager.
          </p>
        </Tooltip>
      </div>
    </Tile>
  )
}
